import { supabase } from './supabaseClient';

/**
 * Servicio para gestión de usuarios en la tabla usuarios
 */
// Función para eliminar transacción
export const eliminarTransaccion = async (transaccionId) => {
  try {
    console.log('Eliminando transacción:', transaccionId);
    
    const { data, error } = await supabase
      .from('transacciones')
      .delete()
      .eq('id', transaccionId)
      .select();
    
    if (error) throw error;
    
    console.log('Transacción eliminada exitosamente:', data);
    return data[0];
  } catch (error) {
    console.error('Error al eliminar transacción:', error);
    throw error;
  }
};
// Función para calcular días restantes
const calcularDiasRestantes = (fechaFin) => {
  if (!fechaFin) return 0;
  
  try {
    const hoy = new Date();
    const fin = new Date(fechaFin);
    
    // Asegurarse de que las fechas sean válidas
    if (isNaN(fin.getTime())) {
      console.warn('⚠️ Fecha de fin inválida:', fechaFin);
      return 0;
    }
    
    const diffTime = fin - hoy;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  } catch (error) {
    console.error('❌ Error calculando días restantes:', error);
    return 0;
  }
};

// Función para calcular el estado basado en días restantes (como tu main.py)
const calcularEstado = (diasRestantes) => {
  if (diasRestantes > 5) return 'VIGENTE';
  if (diasRestantes > 0) return 'POR_VENCER';
  return 'VENCIDO';
};

/**
 * Obtener todos los usuarios con cálculos automáticos
 */
export const obtenerUsuarios = async () => {
  try {
    console.log('🔍 Obteniendo usuarios de la tabla usuarios...');
    
    const { data, error } = await supabase
      .from('usuarios')
      .select('*');

    if (error) {
      console.error('❌ Error obteniendo usuarios:', error);
      console.error('❌ Código de error:', error.code);
      console.error('❌ Mensaje:', error.message);
      console.error('❌ Detalles:', error.details);
      throw error;
    }

    console.log('✅ Usuarios obtenidos exitosamente:', data?.length || 0, 'registros');

    // Calcular días restantes y estado para cada usuario
    const usuariosConCalculos = data.map(usuario => {
      const diasRestantes = calcularDiasRestantes(usuario.fecha_fin);
      const estado = calcularEstado(diasRestantes);
      
      return {
        ...usuario,
        dias_restantes: diasRestantes,
        estado: estado
      };
    });

    console.log('✅ Cálculos completados para', usuariosConCalculos.length, 'usuarios');
    return usuariosConCalculos;
  } catch (error) {
    console.error('❌ Error en obtenerUsuarios:', error);
    
    // Proporcionar más información sobre el error
    if (error.code === 'PGRST116') {
      throw new Error('La tabla "usuarios" no existe o está vacía');
    } else if (error.code === '42501') {
      throw new Error('Sin permisos para acceder a la tabla "usuarios". Verifica RLS.');
    } else if (error.message?.includes('relation') || error.message?.includes('does not exist')) {
      throw new Error('La tabla "usuarios" no existe en la base de datos');
    } else {
      throw new Error(`Error de base de datos: ${error.message}`);
    }
  }
};
export const crearUsuario = async (datosUsuario) => {
  try {
    console.log('🔄 Creando nuevo usuario...');
    
    // Calcular días restantes basado en la fecha_fin que viene del frontend
    const diasRestantes = calcularDiasRestantes(datosUsuario.fecha_fin);
    const estado = calcularEstado(diasRestantes);
    
    const usuarioCompleto = {
      ...datosUsuario,
      // Mantener la fecha_fin que viene del frontend (ya calculada correctamente)
      fecha_fin: datosUsuario.fecha_fin,
      // Conversiones correctas que respetan el 0
      valor: parseFloat(datosUsuario.valor) || 0,
      mes_suscripcion: parseInt(datosUsuario.mes_suscripcion) || 0,
      dias_adicionales: parseInt(datosUsuario.dias_adicionales) || 0,
      curso_tipo: datosUsuario.curso_tipo || null,
      // AGREGAR ESTOS CAMPOS REQUERIDOS:
      dias_restantes: diasRestantes,
      estado: estado
    };

    console.log('📊 Usuario a crear:', {
      correo: usuarioCompleto.correo,
      fechaInicio: usuarioCompleto.fecha_inicio,
      meses: usuarioCompleto.mes_suscripcion,
      dias: usuarioCompleto.dias_adicionales,
      fechaFin: usuarioCompleto.fecha_fin,
      diasRestantes: usuarioCompleto.dias_restantes,
      estado: usuarioCompleto.estado,
      curso_tipo: usuarioCompleto.curso_tipo
    });

    const { data, error } = await supabase
      .from('usuarios')
      .insert([usuarioCompleto])
      .select();

    if (error) {
      console.error('❌ Error creando usuario:', error);
      throw error;
    }

    console.log('✅ Usuario creado exitosamente:', data[0]);
    return data[0];
  } catch (error) {
    console.error('❌ Error en crearUsuario:', error);
    throw new Error('Error al crear el usuario: ' + error.message);
  }
};
// Función para actualizar transacción
export const actualizarTransaccion = async (transaccionId, transaccionData) => {
  try {
    console.log('Actualizando transacción:', transaccionId, transaccionData);
      const dataToUpdate = {
      ...transaccionData,
      curso_tipo: transaccionData.curso_tipo || null // ✅ AGREGAR
    };
       const { data, error } = await supabase
      .from('transacciones')
      .update(dataToUpdate)
      .eq('id', transaccionId)
      .select();
    
    if (error) throw error;
    
    console.log('Transacción actualizada exitosamente:', data);
    return data[0];
  } catch (error) {
    console.error('Error al actualizar transacción:', error);
    throw error;
  }
};
/**
 * Actualizar un usuario existente
 */  
export const actualizarUsuario = async (correo, datosUsuario) => {
  try {
    console.log('🔄 Actualizando usuario:', correo);
    
    // Calcular fecha_fin si se proporcionan fecha_inicio y mes_suscripcion
    let usuarioActualizado = { ...datosUsuario };
 
    // Convertir tipos de datos
    if (usuarioActualizado.valor) {
      usuarioActualizado.valor = parseFloat(usuarioActualizado.valor);
    }
    if (usuarioActualizado.mes_suscripcion) {
      usuarioActualizado.mes_suscripcion = parseInt(usuarioActualizado.mes_suscripcion);
    }
    if (usuarioActualizado.dias_adicionales) {
      usuarioActualizado.dias_adicionales = parseInt(usuarioActualizado.dias_adicionales);
    }

    // **RECALCULAR días restantes y estado (igual que tu main.py)**
    if (usuarioActualizado.fecha_fin) {
      const diasRestantes = calcularDiasRestantes(usuarioActualizado.fecha_fin);
      const estado = calcularEstado(diasRestantes);
      
      usuarioActualizado.dias_restantes = diasRestantes;
      usuarioActualizado.estado = estado;
      
      console.log('📊 Usando fecha_fin calculada desde Admin:', {
        fechaFin: usuarioActualizado.fecha_fin,
        diasRestantes: diasRestantes,
        estado: estado
      });
    }

    // No incluir updated_at si no existe en tu tabla
    // usuarioActualizado.updated_at = new Date().toISOString();

    const { data, error } = await supabase
      .from('usuarios')
      .update(usuarioActualizado)
      .eq('correo', correo)
      .select();
      
    if (error) {
      console.error('❌ Error actualizando usuario:', error);
      throw error;
    }

    if (!data || data.length === 0) {
      throw new Error('Usuario no encontrado');
    }

    console.log('✅ Usuario actualizado exitosamente:', data[0]);
    return data[0];
  } catch (error) {
    console.error('❌ Error en actualizarUsuario:', error);
    throw new Error('Error al actualizar el usuario: ' + error.message);
  }
};

/**
 * Eliminar un usuario
 */
export const eliminarUsuario = async (correo) => {
  try {
    const { data, error } = await supabase
      .from('usuarios')
      .delete()
      .eq('correo', correo)
      .select();

    if (error) {
      console.error('Error eliminando usuario:', error);
      throw error;
    }

    if (!data || data.length === 0) {
      throw new Error('Usuario no encontrado');
    }

    console.log('✅ Usuario eliminado exitosamente:', data[0]);
    return data[0];
  } catch (error) {
    console.error('Error en eliminarUsuario:', error);
    throw new Error('Error al eliminar el usuario: ' + error.message);
  }
};

/**
 * Verificar si un correo ya existe
 */
export const verificarCorreoExiste = async (correo) => {
  try {
    const { data, error } = await supabase
      .from('usuarios')
      .select('correo')
      .eq('correo', correo)
      .single();

    if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
      console.error('Error verificando correo:', error);
      throw error;
    }

    return !!data; // Retorna true si existe, false si no
  } catch (error) {
    console.error('Error en verificarCorreoExiste:', error);
    return false;
  }
};

/**
 * Obtener estadísticas generales
 */
export const obtenerEstadisticas = async () => {
  try {
    const usuarios = await obtenerUsuarios();
    
    const stats = {
      total: usuarios.length,
      vigentes: usuarios.filter(u => u.estado === 'VIGENTE').length,
      por_vencer: usuarios.filter(u => u.estado === 'POR_VENCER').length,
      vencidos: usuarios.filter(u => u.estado === 'VENCIDO').length,
      ingresos_totales: usuarios.reduce((sum, u) => sum + (u.valor || 0), 0),
      ingresos_vigentes: usuarios
        .filter(u => u.estado === 'VIGENTE')
        .reduce((sum, u) => sum + (u.valor || 0), 0)
    };

    return stats;
  } catch (error) {
    console.error('Error en obtenerEstadisticas:', error);
    throw new Error('Error al obtener estadísticas');
  }
};

/**
 * Probar conexión con Supabase
 */
export const probarConexionAdmin = async () => {
  try {
    const { data, error } = await supabase
      .from('usuarios')
      .select('count')
      .limit(1);

    if (error) {
      console.error('Error de conexión:', error);
      return false;
    }

    console.log('✅ Conexión a Supabase exitosa');
    return true;
  } catch (error) {
    console.error('Error probando conexión:', error);
    return false;
  }
};

// Función para crear una nueva transacción
export const crearTransaccion = async (transaccionData) => {
  try {
    const { data, error } = await supabase
      .from('transacciones')
      .insert([{
        celular: transaccionData.celular,
        correo: transaccionData.correo,
        plan: transaccionData.plan,
        valor: parseFloat(transaccionData.valor),
        medio_pago: transaccionData.medio_pago,
        comprobante: transaccionData.comprobante,
        cant_meses: parseInt(transaccionData.cant_meses),
        flag_depositado: transaccionData.flag_depositado || false,
         flag_emitido: transaccionData.flag_emitido || false,
         curso_tipo: transaccionData.curso_tipo || null, 
        created_at: new Date().toISOString()
      }])
      .select();

    if (error) throw error;
    return data[0];
  } catch (error) {
    throw new Error(`Error al registrar el pago: ${error.message}`);
  }
};

// Función para obtener todas las transacciones
export const obtenerTransacciones = async () => {
  try {
    const { data, error } = await supabase
      .from('transacciones')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    throw new Error(`Error al obtener transacciones: ${error.message}`);
  }
};

// Función para obtener estadísticas de transacciones
export const obtenerEstadisticasTransacciones = async () => {
  try {
    const { data, error } = await supabase
      .from('transacciones')
      .select('valor, plan, cant_meses');

    if (error) throw error;

    const estadisticas = {
      total_transacciones: data.length,
      ingresos_totales: data.reduce((sum, t) => sum + (t.valor || 0), 0),
      por_plan: {},
      meses_vendidos: data.reduce((sum, t) => sum + (t.cant_meses || 0), 0)
    };

    data.forEach(transaccion => {
      const plan = transaccion.plan || 'Sin plan';
      if (!estadisticas.por_plan[plan]) {
        estadisticas.por_plan[plan] = { cantidad: 0, ingresos: 0 };
      }
      estadisticas.por_plan[plan].cantidad++;
      estadisticas.por_plan[plan].ingresos += transaccion.valor || 0;
    });

    return estadisticas;
  } catch (error) {
    throw new Error(`Error al obtener estadísticas: ${error.message}`);
  }

  
};

// ✅ FUNCIÓN PARA ACTIVIDAD DE USUARIOS
export const obtenerUsuariosConectadosPorFecha = async (fecha) => {
  try {
    const [year, month, day] = fecha.split('-').map(Number);
    const inicio = new Date(year, month - 1, day, 0, 0, 0, 0);
    const fin = new Date(year, month - 1, day, 23, 59, 59, 999);
    const { data, error } = await supabase
      .from('usuarios')
      .select('correo, nombre, empresa, plan, ultimo_acceso')
      .gte('ultimo_acceso', inicio.toISOString())
      .lte('ultimo_acceso', fin.toISOString())
      .order('ultimo_acceso', { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error obteniendo actividad por fecha:', error);
    throw new Error(`Error al obtener actividad: ${error.message}`);
  }
};

// ✅ NUEVAS FUNCIONES PARA ANUNCIOS
export const obtenerEstadisticasAnuncio = async () => {
  try {
    // Estadísticas de seace_news
    const { data: seaceNews, error: seaceError } = await supabase
      .from('seace_news')
      .select('departamento, objeto');
    
    if (seaceError) throw seaceError;

    // Estadísticas de contratos_menores (solo convocatorias_hoy = 1)
    const { data: contratosMenores, error: contratosError } = await supabase
      .from('contratos_menores')
      .select('departamento, tipo')
      .eq('convocatorias_hoy', 1);
    
    if (contratosError) throw contratosError;

    // Procesar datos de seace_news
    const seacePorDpto = {};
    const seacePorObjeto = {};
    
    seaceNews.forEach(item => {
      const dpto = item.departamento || 'SIN DEPARTAMENTO';
      const objeto = item.objeto || 'SIN OBJETO';
      
      seacePorDpto[dpto] = (seacePorDpto[dpto] || 0) + 1;
      seacePorObjeto[objeto] = (seacePorObjeto[objeto] || 0) + 1;
    });

    // Procesar datos de contratos_menores
    const menoresPorDpto = {};
    const menoresPorTipo = {};
    
    contratosMenores.forEach(item => {
      const dpto = item.departamento || 'SIN DEPARTAMENTO';
      const tipo = item.tipo || 'SIN TIPO';
      
      menoresPorDpto[dpto] = (menoresPorDpto[dpto] || 0) + 1;
      menoresPorTipo[tipo] = (menoresPorTipo[tipo] || 0) + 1;
    });

    return {
      seace_news: {
        total: seaceNews.length,
        por_departamento: seacePorDpto,
        por_objeto: seacePorObjeto
      },
      contratos_menores: {
        total: contratosMenores.length,
        por_departamento: menoresPorDpto,
        por_tipo: menoresPorTipo
      }
    };
  } catch (error) {
    console.error('Error obteniendo estadísticas para anuncio:', error);
    throw error;
  }
};

export const guardarConfiguracionAnuncio = async (grupoId) => {
  try {
    const { data, error } = await supabase
      .from('configuracion_anuncios')
      .upsert({ 
        id: 1,
        grupo_whatsapp_id: grupoId,
        updated_at: new Date().toISOString()
      }, { onConflict: 'id' })
      .select()
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error guardando configuración:', error);
    throw error;
  }
};

export const obtenerConfiguracionAnuncio = async () => {
  try {
    const { data, error } = await supabase
      .from('configuracion_anuncios')
      .select('grupo_whatsapp_id')
      .eq('id', 1)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return { grupo_whatsapp_id: 'D2Dq4IKd4IhDca8zuAIH3a' };
      }
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error obteniendo configuración:', error);
    return { grupo_whatsapp_id: 'D2Dq4IKd4IhDca8zuAIH3a' };
  }
};

// ✅ CONFIGURACIÓN DE ACCESOS POR PLAN
// Una sola fila (id = 1) en configuracion_accesos con dos cosas:
//
//  • generador_oferta_planes: qué planes ven el "Generador de Oferta", como
//    lista de códigos (ej: ['PREMIUM', 'CURSO:GRUPO_16']). ADMI siempre entra.
//  • grupos_curso: el catálogo de grupos del plan Curso. Cada grupo lleva su
//    perfil de acceso, que decide qué secciones ve el alumno en el portal:
//    { id, nombre, descripcion, precio, perfil }
//
// El Sidebar, el guard de rutas y el Generador la necesitan a la vez, así que
// se lee una sola vez y se comparte.
let cacheAccesos = null;
// Copia ya resuelta, para que quien se monte después (el guard de cada ruta)
// pinte con la respuesta correcta desde el primer fotograma en vez de un spinner.
let snapshotAccesos = null;

export const invalidarCacheAccesos = () => { cacheAccesos = null; snapshotAccesos = null; };

export const leerSnapshotAccesos = () => snapshotAccesos;

const normalizarConfigAccesos = (data) => {
  snapshotAccesos = {
    generadorPlanes: (Array.isArray(data?.generador_oferta_planes) ? data.generador_oferta_planes : [])
      .map(p => String(p).trim().toUpperCase()),
    grupos: Array.isArray(data?.grupos_curso) ? data.grupos_curso : []
  };
  return snapshotAccesos;
};

export const obtenerConfiguracionAccesos = () => {
  if (cacheAccesos) return cacheAccesos;

  const leer = (columnas) => supabase
    .from('configuracion_accesos')
    .select(columnas)
    .eq('id', 1)
    .single();

  cacheAccesos = leer('generador_oferta_planes, grupos_curso')
    .then(({ data, error }) => {
      // 42703 = la columna grupos_curso todavía no existe porque la migración
      // no se ha corrido. Se lee lo de siempre para no dejar sin Generador a
      // quien ya lo tenía; los grupos llegan vacíos y todo sigue como antes.
      if (error?.code === '42703') {
        return leer('generador_oferta_planes').then(({ data: previo, error: fallo }) => {
          if (fallo && fallo.code !== 'PGRST116') throw fallo;
          return normalizarConfigAccesos(previo);
        });
      }
      // PGRST116 = aún no hay fila de configuración
      if (error && error.code !== 'PGRST116') throw error;
      return normalizarConfigAccesos(data);
    })
    .catch((error) => {
      console.error('Error obteniendo la configuración de accesos:', error);
      // Un fallo de red no se cachea: el siguiente intento vuelve a preguntar.
      cacheAccesos = null;
      return { generadorPlanes: [], grupos: [] };
    });

  return cacheAccesos;
};

export const guardarAccesosGenerador = async (planes) => {
  // No encadenamos .select() para no requerir permiso de lectura tras el write
  // (si RLS estuviera activo, el insert podría funcionar pero el select fallar).
  const { error } = await supabase
    .from('configuracion_accesos')
    .upsert({
      id: 1,
      generador_oferta_planes: planes,
      updated_at: new Date().toISOString()
    }, { onConflict: 'id' });

  if (error) {
    console.error('Error guardando accesos del generador:', error);
    throw error;
  }
  invalidarCacheAccesos();
  return true;
};

export const guardarGruposCurso = async (grupos) => {
  const { error } = await supabase
    .from('configuracion_accesos')
    .upsert({
      id: 1,
      grupos_curso: grupos,
      updated_at: new Date().toISOString()
    }, { onConflict: 'id' });

  if (error) {
    console.error('Error guardando los grupos de curso:', error);
    throw error;
  }
  invalidarCacheAccesos();
  return true;
};

/**
 * Genera una contraseña nueva para un usuario y guarda solo su hash.
 * Devuelve la contraseña en claro UNA vez: después ya no se puede consultar.
 * Requiere sesión de administrador (la valida la propia base de datos).
 */
export const generarClaveUsuario = async (correo) => {
  const { data, error } = await supabase.rpc('generar_clave_usuario', { p_correo: correo });

  if (error) {
    console.error('Error generando contraseña:', error);
    throw new Error(error.message || 'No se pudo generar la contraseña');
  }

  return data;
};
